import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 

import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';



import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import {  DemoItem } from '@mui/x-date-pickers/internals/demo';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';


import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker';

import dayjs from 'dayjs';

const headCells = [
  
  { id: 'sm_slotname', numeric: false, label: 'Name' },
  { id: 'bm_name', numeric: false, label: 'Branch' },
  { id: 'slottype', numeric: false, label: 'Type' },
    { id: 'sm_maximumnoofpersons', numeric: false, label: 'No. of Persons' },
	{ id: 'sm_order', numeric: false, label: 'Sort' },
	{ id: 'sm_time', numeric: false, label: 'Time' },
   { id: '',  label: '' },
  ]
  function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  };

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});


export default class Slotmanagement extends Component {
	
    constructor(props) {
    super(props);
   

      this.state = {redirect: false,sm_time:'',sm_time1:'',
      Slotdata:[],smid:'',page: 0 ,prevpage:0,totaldata:0,rowsPerPage:20,rowsPaging:[],
	 
	  order:'desc' ,orderBy:'',names:'',searchsubscription:'',type:'',branchdata:[],branchid:'',
	        
      }
       this.updateDonenewParent = this.updateDonenewParent;
	   
	}
	
	updateDonenewParent = (text) => {  this.apicall(this.state.page,this.state.rowsPerPage); }
	
	Search(){
	this.setState({  
      page: 0,
      rowsPerPage:50,
	  prevpage:0,Slotdata:[]
    });
	
 
}
	


	


	componentWillMount  () {
	

	
	document.title = "AthaYog Living - Slot Management";
	
	if(localStorage.getItem("AYLuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Default'
          })
		  }
	this.branchbind();
	
	
	
  this.apicall(this.state.page,this.state.rowsPerPage);
  
} 

 branchbind(){

    axios.get(Serverurl+'ajaxbranch.php?action=getall')
	
    
      .then((resp) => {    
     

	  
	  
	  let BranchApi = resp.data.map(row => {
                      
          return {value: row.bm_id, display:row.bm_name}
        });
		
		 this.setState({
          branchdata: [{value: '', display:'Select Branch'}].concat(BranchApi)
        },()=>{console.log(this.state.branchdata)});
      }).then(data => {
		 
        
      
		
       
      }) 
    
     


} 
  


handleClickSearch=()=>{   
 
  
  this.apicall(this.state.page,this.state.rowsPerPage); 

	
} 

myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});
 
}

apicall(page,rowsPerPage){
	 
	 axios.get(Serverurl+'ajaxslotmanagement.php?action=getall&sm_slotname='+this.state.names+'&sm_slottype='+this.state.type+'&sm_bm_id='+this.state.branchid+'&StartIndex='+page+'&PageSize='+rowsPerPage)
     
	
  .then(resp => {  
		
    if(resp.data.length>0){
		let copy=[50, 100, 150, 200, 250];
			this.setState({  
			  Slotdata: resp.data,  
			   totaldata:parseInt(resp.data[0].count),rowsPaging:copy
			   

		    });
	  
	 
	 
     }
	 else{
		   this.setState({Slotdata:[],totaldata:0});
	 }
 
    });
}





handleChangePage = (event, newPage) => {  

   
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);  });
   
 
    
  };   
  
  
   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
  

   
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
	
	
  }; 
  
  
  handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};


      SlotDelete(smid){  
	
let r = window.confirm("Do you really want to Delete?");
 if(r === true){ //sign Out logic
 var formData = new FormData();
     formData.append('action','delete')
	 formData.append('sm_id',smid)
	 	   
	formData.append('userid',localStorage.getItem("AYLuserid"))
	
	
	 axios.post(Serverurl+"ajaxslotmanagement.php", formData, {
        }).then(res => {
    
             this.setState({  
      prevpage: -1,
    
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); });
   
 
    
  
    
            });
 }
      }
      Slotaddbox(val){
        this.setState({ smid: val },()=>{this.refs.AddSlotbox.handleClickOpen()});  
  
         

      }

render() {

if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }


  return (
  
  
  



 
  <React.Fragment>
   

<div className="boxheading">
				
<h2>Manage Slot</h2>
</div>
<div className="clear"></div>
   <div className="searchmaster">


  
  <ul>
  
 <li><p>Slot</p>
 <p ><TextField
            variant="outlined"
            margin="normal"
            fullWidth value={this.state.names}
        inputProps={{tabIndex: "1",maxLength:150}} className="txtbox"
			placeholder="Name"
            name="names" onChange={this.myChangeHandler}
		
          /></p></li>
		
	<li><p>Type</p>
	<p><FormControl  className="stadrp">
				
		 <Select
         native
		 variant="outlined" inputProps={{tabIndex: "2"}}
		  className="txtbox"
          margin="normal"
          onChange={this.myChangeHandler}
          id="type"
		   value={this.state.type}
		  name="type"
		
        >
	
	<option value="">Select Your Type</option>
                  <option value={1}>Personal Training at Home</option>
          <option value={2}>Personal Training in studio</option>
 <option value={3}>Group</option>
 <option value={4}>Prenatal</option>
 <option value={6}>Personal Training Online</option>
 <option value={7}>TTC</option>
        </Select>

		</FormControl>
		</p>
	</li>		
	<li>
	<p>Branch</p><p>
	<FormControl  className="stadrp">
         
        <Select
         native  fullWidth		 
		 variant="outlined"
            margin="normal"  inputProps={{tabIndex: "3"}}
		  className="txtbox"
		  defaultValue={{ label: this.state.branchlabel, value: this.state.branchid }}
          onChange={this.myChangeHandler}
          id="branchid"
		   value={this.state.branchid}
		  name="branchid"
		
		
        >
		{this.state.branchdata.map(br => (
            <option  
            
              value={br.value}
            >
              {br.display}
            </option  >
          ))}
		
        </Select></FormControl></p>
	</li>
	
		
		<li><p >
		<Button variant="contained" onClick={this.handleClickSearch} className="frmSecondarybtn" endIcon={<SearchIcon />}>
        Search
      </Button>&nbsp;
	  <Button variant="contained" onClick={()=>{this.Slotaddbox(0)}} className="frmSecondarybtn" endIcon={<AddIcon />}>
        New
      </Button></p></li> 
		
		
		
		
		</ul>
		
</div>		



<AddSlotbox ref="AddSlotbox" id={this.state.smid}  updateDonenew={this.updateDonenewParent}/>
<Paper className={useStyles.root}>


  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.Slotdata.length}
            />
                      <TableBody>
                     {stableSort(this.state.Slotdata, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => { 
			
           return (
 <React.Fragment>
 <TableRow key={index} >



<TableCell>{item.sm_slotname}</TableCell>
<TableCell>{item.bm_name}</TableCell>
<TableCell>{item.slottype}</TableCell>
<TableCell>{item.sm_maximumnoofpersons}</TableCell>
<TableCell>{item.sm_order}</TableCell>
<TableCell>{item.sm_time1}</TableCell>
<TableCell align="left">

<Button variant="contained" className="frmSecondarybtn" onClick={()=>{this.Slotaddbox(item.sm_id)}} endIcon={<EditIcon />}>
Edit
</Button>&nbsp;&nbsp;

{(item.delcnt==="0" || item.delcnt1==="0" )&& (
<Button variant="contained" className="frmthirdbtn" onClick={()=>{this.SlotDelete(item.sm_id)}} endIcon={<DeleteIcon />} >
  Delete
</Button>

 )}



 
 </TableCell>
 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="4">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
  <TablePagination  
       
        rowsPerPageOptions={[10,50,100,150]}
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}   
      />   
  </Paper>
    

 </React.Fragment> 

 
 
  );
}
}


export  class  AddSlotbox extends Component {

   constructor(props) {
      super(props)
	  
	  
	  	var today = new Date();

var todaytime=today.getHours() + ":" + today.getMinutes() + ":00" ;



	  

	
	  
      this.state = {
		 sm_time:dayjs(today),sm_time1:todaytime, ordisable:false,btnorSave:'Save',
		   open:false,name:'',sm_id:0,slotname:'',branchid:'',slottype:'',maximumnoofpersons:'',branchdata:[],branchlabel:'Select Branch',errormessage:'',erropen:false,sort:''
	  }
	  
	  
	
	  
      
  }
  
  branchbind(){

    axios.get(Serverurl+'ajaxbranch.php?action=getall')
	
    
      .then((resp) => {    
     

	  
	  
	  let BranchApi = resp.data.map(row => {
                      
          return {value: row.bm_id, display:row.bm_name}
        });
		
		 this.setState({
          branchdata: [{value: '0', display:'Select Branch'}].concat(BranchApi)
        },()=>{console.log(this.state.branchdata)});
      }).then(data => {
		 
        
      
		
       
      }) 
    
     


}  
  

  
 Slotgetdata() {
	
  if(this.props.id!==0)
  {
	  
	   axios.get(Serverurl+'ajaxslotmanagement.php?action=getall&sm_id='+this.props.id)
  .then(resp => {  
		
    if(resp.data.length>0){
    this.setState({ 
     
      sm_id:resp.data[0].sm_id,
	  slotname: resp.data[0].sm_slotname,
      branchid: resp.data[0].sm_bm_id,
slottype: resp.data[0].sm_slottype,	  
noofpersons: resp.data[0].sm_maximumnoofpersons,    
sort: resp.data[0].sm_order,  
sm_time:dayjs(resp.data[0].sm_time),
sm_time1:resp.data[0].sm_time,

  

    });
	
  }
  
});
	  
  }else{
	 this.setState({  
	  slotname:'',	 
	 branches:'',
	 slottype:'',
	 sm_id:0,
	 noofpersons:'',
	  sort:'',
	  sm_time:''
	  }); 
 }
 this.branchbind();
  
    }

Slotclose= (e) => {
	this.setState({open:false, })
}
handleClickOpen = (e) => {
 
  this.setState({open:!this.state.open,  slotname:'',slottype:'',noofpersons:'',
	  sort:'', sm_time:'',
     errormessage:'',erropen:false,branchid:'',rolelabel:'Select Branch',branchdata:[],
	  });
		this.Slotgetdata();
		
};
myChangeHandler = (event) => {
	
	  const re = /^[0-9\b]+$/;
  let nam = event.target.name;
  let val = event.target.value;  
 
  if(nam==="noofpersons"  ) 
  {
	  if (event.target.value === '' || re.test(event.target.value)) {
	  this.setState({[nam]: val}); 
	  
  }
  }
 
 else
 if(nam==="sort"  ) 
  {
	  if (event.target.value === '' || re.test(event.target.value)) {
	  this.setState({[nam]: val}); 
	  
  }
  }
 
 
  
  else{
  this.setState({[nam]: val});
  }
  

}




handleClose = (e) => {
	
	
 let slotname = this.state.slotname;
 let branchid = this.state.branchid;
 let slottype = this.state.slottype;
  let noofpersons = this.state.noofpersons;
    let sort = this.state.sort;
    let sm_time1 = this.state.sm_time1;

if(slotname==="")
{
	
	this.setState({errormessage:"Please Enter Slot Name",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}


if(sm_time1==="")
{
	
	this.setState({errormessage:"Please Select Time",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}



if(branchid==="")
{
	
	this.setState({errormessage:"Please Select Branch",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}

if(slottype===""  )
{
	
	this.setState({errormessage:"Please Select Class Type",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}

if(noofpersons==="" )
{
	
	this.setState({errormessage:"Please Enter Maximum No. of Persons",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
if(sort==="" || sort==="0" )
{
	
	this.setState({errormessage:"Please Enter Sortorder",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
this.setState({errormessage:"",erropen:false, ordisable:true,btnorSave:'Processing...',});

   var formData = new FormData();
  
  
   if(this.state.sm_id===0)
	  {
		  formData.append('sm_id',0) 
		  
	  }
	  else
	  {
		  
	   formData.append('sm_id',this.state.sm_id)
		
          }
	  
	  
	  
	  
	 
        formData.append('action','insertorupdate') 
		
		formData.append('sm_slotname',slotname)
		formData.append('sm_time',sm_time1)
		formData.append('sm_bm_id',branchid)
		formData.append('sm_slottype',slottype)
		formData.append('sm_maximumnoofpersons',noofpersons)
				formData.append('sm_order',sort)
		
		formData.append('userid',localStorage.getItem("AYLuserid"))
		  
		axios.post(Serverurl+"ajaxslotmanagement.php", formData, {
        }).then(res => {
    
	
	
	if(res.data === -1)
{ 
	 

		this.setState({errormessage:"",erropen:true,open:true, ordisable:false,btnorSave:'Save',
		});
		window.scrollTo({
          top: 0
      })
		 return false;

	}else{
	
	this.setState({ open:false,ordisable:false,btnorSave:'Save', });
            this.props.updateDonenew();
	}
    
        });
  
	
	
};

	 handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  } 

handlefromTimeChange = (date) => {

    date = new Date(date);


	 var month=date.getMonth()+1;
	 
	if(month.length===1)
	{
		month="0"+month;
	}
     this.setState({sm_time:date,
sm_time1:date.getFullYear()+'-'+month+'-'+date.getDate()+" "+date.getHours() + ":" + date.getMinutes() +":00" 
	 })
	
  };
  
  
  
  
	
	
  


render (){

return(
<React.Fragment>





    <Dialog open={this.state.open} onClose={this.Slotclose} maxWidth="xs" fullWidth="true" aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title"> Slot Management</DialogTitle>
      <DialogContent>
	  
<div className="formlist">

	<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity="error"
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
						  
						  
		
						  
	<p> <span className="validation">*</span>Slot Name</p>
	
	<p><TextField name="slotname" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.slotname}
			 
			  ref={this.usernameInput}
			inputProps={{tabIndex: "1",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
						  
					  
						  
		
		<p>Time</p>
		<p>
		<LocalizationProvider dateAdapter={AdapterDayjs}>
  <DemoItem >
       <MobileTimePicker 

  ref={this.usernameInput}
			inputProps={{tabIndex: "1",maxLength:150}} className=".txtbox"
	   InputLabelProps={{ shrink: true }}
minutesStep={60} 

	   onChange={this.handlefromTimeChange} views={['hours', 'minutes']} name="sm_time" value={this.state.sm_time}/>
        </DemoItem>
		</LocalizationProvider>
 </p>
		
						  
						  
	   <p> <span className="validation">*</span>Branch</p>
		<p>
		<FormControl  className="stadrp">
         
        <Select
         native  fullWidth		 inputProps={{tabIndex: "2"}}  
		 variant="outlined" className="txtbox"
            margin="normal"
		  defaultValue={{ label: this.state.branchlabel, value: this.state.branchid }}
          onChange={this.myChangeHandler}
          id="branchid"
		   value={this.state.branchid}
		  name="branchid"
		
		
        >
		{this.state.branchdata.map(br => (
            <option  
            
              value={br.value}
            >
              {br.display}
            </option  >
          ))}
		
        </Select></FormControl>
		
		</p>				  
						  
		<p> <span className="validation">*</span>Slot Type</p>				  
						  <p><FormControl  className="stadrp">
				
		 <Select
         native
		 variant="outlined"
          margin="normal" inputProps={{tabIndex: "3"}} className="txtbox" 
          onChange={this.myChangeHandler}
          id="slottype"
		   value={this.state.slottype}
		  name="slottype"
		
        >
	
	<option value="">Select Type</option>
          <option value={1}>Personal Training at Home</option>
          <option value={2}>Personal Training in studio</option>
 <option value={3}>Group</option>
 <option value={4}>Prenatal</option>
 <option value={6}>Personal Training Online</option>
  <option value={7}>TTC</option>
        </Select>

		</FormControl>
		</p>
						  
<p> <span className="validation">*</span> Maxmum no. of Persons</p>
	
	<p><TextField name="noofpersons" 
	   onChange={this.myChangeHandler} 
	   fullWidth 	inputProps={{tabIndex: "4",maxLength:3}} className="txtbox"
	   value={this.state.noofpersons}
			 
			  ref={this.usernameInput}
			  
	   InputLabelProps={{ shrink: true }}
                          /></p>		
						  

	<p> <span className="validation">*</span> Sort Order</p>
	
	<p><TextField name="sort" 
	   onChange={this.myChangeHandler} 
	   fullWidth 	inputProps={{tabIndex: "5",maxLength:4}} className="txtbox"
	   value={this.state.sort}
			 
			  ref={this.usernameInput}
			  
	   InputLabelProps={{ shrink: true }}
                          /></p>
	
		
       <div className="actionbtns">
	   <div className="cancelbtn">	  
	   <Button variant="contained" className="frmthirdbtn" onClick={this.Slotclose}>
Cancel
</Button>
</div> 
<div className="savebtn">
<Button variant="contained" className="frmSecondarybtn" disable={this.state.ordisable} onClick={this.handleClose}>
   {this.state.btnorSave}
</Button>
  </div>     


	
<div className="clear"></div>

 </div>     
	</div>		 
						    </DialogContent>
      
    </Dialog>
</React.Fragment>

) }
 
} 
  